import React from "react";
import { motion } from "framer-motion";
import Header from "../components/Header";

export default function BlogsPage() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <Header />
      <main className="flex-1 flex flex-col">
        <section className="w-full bg-gray-100 py-16 px-4 sm:px-6 lg:px-16 relative overflow-hidden min-h-[calc(100vh-80px)]">
          {/* Subtle background pattern */}
          <div className="absolute inset-0 opacity-[0.03] pointer-events-none">
            <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(#000 1px, transparent 1px)', backgroundSize: '40px 40px' }}></div>
          </div>
          <div className="max-w-7xl mx-auto py-4 lg:py-8">
            {/* Page Title */}
            <div className="text-center mb-16">
              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-black leading-none"
              >
                BL<span className="inline-block relative px-1">
                  <span className="relative z-10">O</span>
                  <span className="absolute inset-0 bg-yellow-400 rounded-full transform scale-105 -z-0"></span>
                </span>GS
              </motion.h1>
              
              <div className="relative mx-auto" style={{ height: '6px', width: '100px', marginTop: '32px', marginBottom: '32px' }}>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.3, duration: 0.7 }}
                  className="bg-black absolute"
                  style={{ height: '6px', width: '100%', left: 0 }}
                ></motion.div>
              </div>
            </div>
            
            {/* Blog Posts Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[1, 2, 3, 4, 5, 6].map((index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.1 * index }}
                  className="bg-white shadow-sm overflow-hidden"
                >
                  <div className="h-48 bg-gray-200 relative">
                    <div className="absolute inset-0 flex items-center justify-center text-gray-400">
                      Blog Image {index}
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="flex justify-between items-center mb-4">
                      <span className="text-xs text-gray-500">September 24, 2025</span>
                      <span className="text-xs font-medium bg-yellow-100 text-yellow-800 px-2 py-1 rounded">Category</span>
                    </div>
                    <h3 className="text-xl font-bold mb-2">Blog Post Title {index}</h3>
                    <p className="text-gray-600 text-sm mb-4">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    </p>
                    <a href="#" className="font-bold text-black border-b-2 border-yellow-400 inline-block hover:border-black transition-colors">
                      Read More
                    </a>
                  </div>
                </motion.div>
              ))}
            </div>
            
            {/* Pagination */}
            <div className="flex justify-center mt-12">
              <div className="flex space-x-2">
                {[1, 2, 3].map((page) => (
                  <button
                    key={page}
                    className={`w-10 h-10 flex items-center justify-center ${
                      page === 1 ? 'bg-black text-white' : 'bg-white text-black border border-gray-200'
                    }`}
                  >
                    {page}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
